import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { useAuth } from '../features/auth/AuthContext';

export function BillingSuccess() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let timeoutId: number;
    let isActive = true;

    async function checkStatus() {
      if (!isActive) return;
      await refresh();
    }

    if (user?.hasActiveMembership) {
      setIsReady(true);
      timeoutId = window.setTimeout(() => {
        if (isActive) navigate('/crates');
      }, 3000);
    } else {
      timeoutId = window.setTimeout(() => {
        void checkStatus();
      }, 2000);
    }

    return () => {
      isActive = false;
      window.clearTimeout(timeoutId);
    };
  }, [user?.hasActiveMembership, refresh, navigate]);

  return (
    <section className="container-shell py-16">
      <PageHeader
        title={isReady ? "You're in. Your PrimeTime Credits are ready." : "Completing Setup..."}
        subtitle={isReady ? "Redirecting you to the catalog." : "We're finishing your account setup. This usually takes a few seconds."}
      />

      <div className="mx-auto max-w-3xl rounded-2xl border border-white/10 bg-white/[0.04] p-8 text-center">
        {isReady ? (
          <div className="space-y-6">
             <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-prime-red/20 text-prime-red">
               <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
               </svg>
             </div>
             <p className="text-sm leading-7 text-white/70">
               Your membership is active and your credits have been applied.
             </p>
             <button
               onClick={() => navigate('/crates')}
               className="btn-primary mt-4"
             >
               Start Browsing Crates
             </button>
          </div>
        ) : (
           <div className="space-y-6">
             <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-prime-red border-t-transparent"></div>
             <p className="text-sm leading-7 text-white/70 animate-pulse">
               Waiting for confirmation...
             </p>
          </div>
        )}
      </div>
    </section>
  );
}
